import { useEffect, useState } from "react";
import { _Entailment } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { AppointmentManualEditor } from "../AppointmentManual/AppointmentManual.editor";
import { AppointmentGroupManualEditor } from "../AppointmentGroupManual/AppointmentGroupManual.editor";
import { _ContributorSubtype, _ContributorType, _EmployeeContractType } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { InputDate } from "../../../theme/Input/InputDate";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";


export const ContributorSubtype = () => {

    const contributorsub = useDataBean(_ContributorSubtype);
    const single = Singleton.getInstance();

    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {

        contributorsub.instance.getContributorSubtypeCatalog(null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    const create = () => {
        contributorsub.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        contributorsub.instance.deleteContributorSubtype(contributorsub.bean.IDContributorSubtype).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        if (!contributorsub.bean.Code) {
            toast.warning("Debe proporcionar un Código.");
            return;
        }
        if (!contributorsub.bean.Name) {
            toast.warning("Debe proporcionar un Nombre.");
            return;
        }
        if (!contributorsub.bean.Description) {
            toast.warning("Debe proporcionar una Descripción.");
            return;
        }
        if (!contributorsub.bean.WorkSheetCode) {
            toast.warning("Debe proporcionar un Tipo de Planilla de Pago.");
            return;
        }
        contributorsub.instance.updateContributorSubtype(contributorsub.bean).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDContributorType', visible: true },
        { title: 'Código', property: 'Code', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'EPS', property: 'EPS', visible: true },
        { title: 'ARP', property: 'ARP', visible: true },
        { title: 'CCF', property: 'CCF', visible: true },
        { title: 'AFP', property: 'AFP', visible: true },
        { title: 'SENA', property: 'SENA', visible: true },
        { title: 'ICBF', property: 'ICBF', visible: true },
        { title: 'FONDO DE SOLIDARIDAD', property: 'SOLIDARY_AFP', visible: true },
        { title: 'FONDO DE SUBSISTENCIA', property: 'SUBSISTENCE_AFP', visible: true },
        { title: 'CESANTÍAS', property: 'FCE', visible: true },
        { title: 'Tipo de Planilla de Pago', property: 'WorkSheetCode', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${contributorsub.bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Subtipos de Cotizante">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={contributorsub.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-6">
                                <label>Código</label>
                                <input type="text" name="Code" className="form-control" value={contributorsub.bean.Code} onChange={contributorsub.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={contributorsub.bean.Name} onChange={contributorsub.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Tipo de Planilla de Pago</label>
                                <input type="text" name="WorkSheetCode" className="form-control" value={contributorsub.bean.WorkSheetCode} onChange={contributorsub.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label="EPS" estado={contributorsub.bean.EPS} eventChange={(e: any) => { contributorsub.setBean({ ...contributorsub.bean, "EPS": e }) }}></BasicSwitch>
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label="ARP" estado={contributorsub.bean.ARP} eventChange={(e: any) => { contributorsub.setBean({ ...contributorsub.bean, "ARP": e }) }}></BasicSwitch>
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label="CCF" estado={contributorsub.bean.CCF} eventChange={(e: any) => { contributorsub.setBean({ ...contributorsub.bean, "CCF": e }) }}></BasicSwitch>
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label="AFP" estado={contributorsub.bean.AFP} eventChange={(e: any) => { contributorsub.setBean({ ...contributorsub.bean, "AFP": e }) }}></BasicSwitch>
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label="SENA" estado={contributorsub.bean.SENA} eventChange={(e: any) => { contributorsub.setBean({ ...contributorsub.bean, "SENA": e }) }}></BasicSwitch>
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label="ICBF" estado={contributorsub.bean.ICBF} eventChange={(e: any) => { contributorsub.setBean({ ...contributorsub.bean, "ICBF": e }) }}></BasicSwitch>
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label="FONDO DE SOLIDARIDAD" estado={contributorsub.bean.SOLIDARY_AFP} eventChange={(e: any) => { contributorsub.setBean({ ...contributorsub.bean, "SOLIDARY_AFP": e }) }}></BasicSwitch>
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label="FONDO DE SUBSISTENCIA" estado={contributorsub.bean.SUBSISTENCE_AFP} eventChange={(e: any) => { contributorsub.setBean({ ...contributorsub.bean, "SUBSISTENCE_AFP": e }) }}></BasicSwitch>
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label="CESANTÍAS" estado={contributorsub.bean.FCE} eventChange={(e: any) => { contributorsub.setBean({ ...contributorsub.bean, "FCE": e }) }}></BasicSwitch>
                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <input type="text" name="Description" className="form-control" value={contributorsub.bean.Description} onChange={contributorsub.handleChange} />
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {contributorsub.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}